import { Button } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import InputForm from "../../../../components/Basic/InputForm";
import Icon, { ICON_NAME } from "../../../../components/Icon";
import LoadingBox from "../../../../components/LoadingBox";
import { callEventEditVessel, useEditVessel } from "../../../../contexts/EditVesselContext";
import { VesselService } from "../../../../util/services/vessel";
import { firstLetter, showErrorResponse } from "../../../../util/varibles/global";
import { IStorage } from "../../../../util/varibles/interface";
import { storageForm } from "../constants";
import styles from "../style.module.scss";

const keys = ['name', 'value', 'speed'];

const TankInput: React.FC<{
    id: number,
    data: IStorage | any,
    onChange: (value: Partial<IStorage>) => void,
    onRemove?: () => void
}> = ({ id, data, onChange, onRemove }) => {

    const handleChange = (value: Partial<IStorage>) => onChange(value)
    const [error = {}] = useEditVessel(state => {
        const { [id]: selector } = state.error?.storages || {};
        return selector
    })

    const { type, group_type } = data || {};

    return <div className={styles.tank}>
        {keys.map(item => {
            const { [type]: props = {} } = storageForm[group_type] || {};
            if (!props[item])
                return null
            const { [props[item].type]: Input } = InputForm;

            return <Input
                {...props[item] || {}}
                inputClassName='h-[36px]'
                key={item}
                error={error[item]}
                value={data[item]}
                onChange={value => handleChange({ [item]: value })}
            />
        })}
        {onRemove && <Button className='bt-ghost' data-icon='true' data-danger={true}
            onClick={onRemove}>
            <Icon icon={ICON_NAME.DELETE} />
        </Button>}
    </div>
}

const Storages: React.FC = () => {
    const [value = [], setStore] = useEditVessel(state => state.vessel?.storages);
    const [{ storageTypes, loading }, setStorageTypes] = useState<{ loading: boolean, storageTypes: any[] }>({
        loading: false,
        storageTypes: []
    });
    const storageRef = useRef<HTMLDivElement>(null);
    const { updateStorage, deleteStorage } = callEventEditVessel();
    const timeout = useRef(setTimeout(() => {
    }));

    useEffect(() => {
        setStorageTypes(prev => ({ ...prev, loadingStorages: true }));
        VesselService.storages()
            .then(rs => setStorageTypes({ loading: false, storageTypes: rs }))
            .catch(error => {
                showErrorResponse('Get tanks failed', error);
                setStorageTypes({ loading: false, storageTypes: [] });
            })
    }, []);

    const handleAdd = useCallback(() => {
        if (!loading && storageTypes[0]) {
            const { id, name, type, group_type } = storageTypes[0];
            setStore(({ vessel: old }) => ({
                vessel: {
                    ...old,
                    storages: [
                        ...old?.storages || [],
                        {
                            name: '',
                            speed: 0,
                            value: 0,
                            group_id: id,
                            group_name: firstLetter(name),
                            group_type,
                            type
                        }
                    ]
                }
            }))

            if (timeout.current)
                clearTimeout(timeout.current)

            timeout.current = setTimeout(() => {
                const el = storageRef.current;
                if (el) {
                    const tankEl = el.lastChild;
                    if (tankEl) {
                        const target = tankEl.firstChild as HTMLDivElement;
                        if (target) {
                            const inputEl = target.getElementsByTagName('input')[0];
                            inputEl?.focus();
                        }
                    }
                }
            }, 300);
        }
        // const el = openPopup(<PopupAddStorages
        //     onAdd={callback}
        //     onClose={() => setTimeout(() => el.remove(), 300)}
        // />)
    }, [loading, storageTypes, setStore]);

    return <div>
        <div className='flex items-center gap-2'>
            <span className='text-[15px] mt-1'>Add tank equipment</span>
            <Button className="bt-ghost" loading={loading} data-icon={true}
                size='small'
                onClick={() => handleAdd()}>
                <Icon icon={ICON_NAME.ADD_2} size='small' />
            </Button>
        </div>
        {value.length === 0 && <LoadingBox className='mt-3 max-w-[300px]' loading={false} />}
        <div ref={storageRef} className='mb-1'>
            {value.map((item, i) => <TankInput
                key={i}
                id={i}
                data={item}
                onChange={sub => updateStorage(i, sub)}
                onRemove={!!i ? () => deleteStorage(i) : undefined}
            />)}
        </div>
    </div>
};

export default Storages;
